{"termsAndPrivacyButtons":"続行することで、FINSIGHT<br />の  <termsOfUse>利用規約</termsOfUse> および <privacyPolicy>プライバシーポリシー</privacyPolicy>に同意したものとみなされます"}